<template>
    <div>
        <basic-container>
            <avue-crud :option="tableOption"
                       :data="tableData"
                       :table-loading="tableLoading"
                       :page="page"
                       ref="crud"
                       @search-change="searchChange"
                       @refresh-change="refreshChange"
                       @row-save="handleSave"
                       @row-update="handleUpdate"
                       @selection-change="handleSelectionChange"
                       @size-change="pageSizeChange"
                       @current-change="pageChange">
                <template slot-scope="scope" slot="menuLeft">


                </template>
                <template slot-scope="scope" slot="menu">

                </template>
                <template slot-scope="scope" slot="ruleIdForm">
                    <el-select v-model="pledgeType"
                               placeholder="请选择押金解冻规则"
                               required
                               value-key="ruleId">
                        <el-option v-for="pledgeType in pledgeTypes"
                                   :key="pledgeType.ruleId" :label="pledgeType.name"
                                   :value="pledgeType"></el-option>
                    </el-select>
                </template>
            </avue-crud>


        </basic-container>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {depositRecordOption} from "@/const/salesCloud/depositRecordOption";
    import {findDepositRecord} from "@/api/salesCloud/depositRecord"
    import {findByLabel} from "@/util/util"
    import {DIC} from "@/const/dic"
    export default {
        name: "depositRecord",
        components: {
        },
        data() {
            return {
                tableOption: depositRecordOption, //表格设置属性
                tableData: [], //表格的数据
                tablePage: 1,
                tableLoading: false,
                tabelObj: {},
                page: {
                    total: 0, //总页数
                    currentPage: 1, //当前页数
                    pageSize: 10 //每页显示多少条
                },
                grade: {
                    box: false,
                    check: []
                },
                pledgeTypes: [],
                pledgeType: {},
                QRCodeDialog: false,
                config: {}
            };
        },
        created() {
            this.handleList();
        },
        watch: {},
        mounted() {
        },
        computed: {
            ...mapGetters(["permission"])
        },
        props: [],
        methods: {
            pageSizeChange(pageSize) {
                this.tableLoading = true;
                let params = this.$refs.crud.searchForm
                params.page = this.page.currentPage,
                    params.size = pageSize
                findDepositRecord(params).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: this.page.currentPage,
                        pageSize: pageSize
                    };
                    this.tableLoading = false;
                })
            },
            pageChange(page) {
                this.tableLoading = true;
                let params = this.$refs.crud.searchForm
                params.page = page
                params.size = this.page.pageSize
                findDepositRecord(params).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: page,
                        pageSize: this.page.pageSize
                    };
                    this.tableLoading = false;
                })
            },
            searchChange(params) {
                this.tableLoading = true;
                // let params = this.$refs.crud.searchForm
                params.page = this.page.currentPage
                params.size = this.page.pageSize
                findDepositRecord(params).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: params.page,
                        pageSize: params.size
                    };
                    this.tableLoading = false;
                })
            },
            refreshChange(page) {
                this.tableLoading = true;
                let params = this.$refs.crud.searchForm
                params.page = page.currentPage
                params.size = page.pageSize
                findDepositRecord(params).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: page.currentPage,
                        pageSize: page.pageSize
                    };
                    this.tableLoading = false;
                })
            },
            /**
             * @title 打开新增窗口
             * @detail 调用crud的handleadd方法即可
             *
             **/
            handleAdd() {
                // this.clean()
                this.$refs.crud.rowAdd();
            },
            handleEdit(row, index) {
                // this.clean()
                // this.clientType = this.formatClientType(row.useCustomerType)
                // this.joinsWorkServiceCategory = {id: row.serviceCategoryId}
                // this.choseWorkServiceItem();
                // this.joinsWorkServiceItem = {id: row.serviceItemId}
                // if (row.startTime != null && row.endTime != null) {
                //     let array = []
                //     array.push(row.startTime)
                //     array.push(row.endTime)
                //     row.startTime_endTime = array
                // }
                this.$refs.crud.rowEdit(row, index);
            },
            /**
             * @title 获取数据
             * @detail 赋值为tableData表格即可
             *
             **/
            handleList() {
                this.tableLoading = true;
                let parmas = {
                    page: this.page.currentPage,
                    size: this.page.pageSize
                }
                findDepositRecord(parmas).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: this.page.currentPage,
                        pageSize: this.page.pageSize
                    };
                    this.tableLoading = false;
                })
            },
            /**
             * @title 数据添加
             * @param row 为当前的数据
             * @param done 为表单关闭函数
             *
             **/
            handleSave(row, done) {
                // let obj = {}
                // obj.account = row.account
                // obj.amount = row.amount
                // obj.targetClientType = row.clientType
                // obj.payType = row.payType
                // obj.ruleId = this.pledgeType.ruleId
                // addPledge(obj).then(response => {
                //     this.tableLoading = false;
                //     if (response.code == '200') {
                //         let data = response.data
                //         wxNativePayQuery(data.outTradeNo).then((res) => {
                //             console.log(res)
                //             if (res.code == '200') {
                //                 if(res.data=='SUCCESS'){
                //                     this.QRCodeDialog = false
                //                     this.$message({
                //                         showClose: true,
                //                         message: "充值成功",
                //                         type: "success"
                //                     })
                //                 }else{
                //                     this.QRCodeDialog = false
                //                     this.$message({
                //                         showClose: true,
                //                         message: "支付超时",
                //                         type: "error"
                //                     })
                //                 }
                //                 this.handleList();
                //             }else{
                //                 this.QRCodeDialog = false
                //                 this.$message({
                //                     showClose: true,
                //                     message: "支付超时",
                //                     type: "error"
                //                 })
                //                 this.handleList();
                //             }
                //         })
                //         let start = new Date().getTime();
                //         while(true)  if(new Date().getTime()-start > 1) break;
                //         this.config.value = ""
                //         this.config.value = data.codeUrl
                //         this.QRCodeDialog = true
                //         // loading.close();
                //     } else {
                //         this.$message({
                //             showClose: true,
                //             message: response.message,
                //             type: "error"
                //         })
                //         done();
                //         this.$refs.crud.rowAdd();
                //         return
                //     }
                //
                // }).catch(error => {
                //     this.loading = false
                //     this.$message({
                //         showClose: true,
                //         message: error,
                //         type: "error"
                //     })
                // })
                // done();
            },
            /**
             * @title 当前选中的数据
             * @param val 选中的值
             *
             **/
            handleSelectionChange() {
                // console.log(val);
                // this.tableRow = val;
                // this.$notify({
                //     showClose: true,
                //     message: JSON.stringify(val),
                //     type: 'success',
                // });
            },
            /**
             * @title 数据删除
             * @param row 为当前的数据
             * @param index 为当前更新数据的行数
             *
             **/
            handleDel(dicName, label) {


            },
            /**
             * @title 数据更新
             * @param row 为当前的数据
             * @param index 为当前更新数据的行数
             * @param done 为表单关闭函数
             *
             **/
            handleUpdate(row, index, done) {

            }

        }
    };
</script>

<style lang="scss">
    .table-container {
        padding: 8px 10px;
    }

    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
</style>
